import { FormBase } from "../form-base";

export class Select extends FormBase<string> {
  controlType = 'select';
  options: {key: string, value: string}[] = [];

  constructor(options: Record<string, any> = {}) {
    super(options);
    this.options = options['options'] || [];
  }
}